import { mobile } from '@bilibili-maoer/web-utils'

import { useEffect } from 'react'

export type TitleChildren = string | string[]
export const Title = (props: { children: TitleChildren }) => {
  useEffect(() => {
    const pageTitle = `${typeof props.children === 'string' ? props.children : props.children.join(' - ')} - `
    const mainTitle = `直播间${mobile.isMissEvanApp() ? '' : ' - 猫耳FM'}`
    document.title = `${pageTitle}${mainTitle}`
    return () => {
      document.title = mainTitle
    }
  }, [props.children])
  return null
}
